// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__1rgjs","text":"Hero_text__3nP5P","point1":"Hero_point1__2mnUw"};